var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit-assigned-screen"},[_c('div',{staticClass:"ea-topbar"},[_c('back-button')],1),(_vm.loading)?_c('skeleton-loader',{attrs:{"type":"assigned-editor"}}):(_vm.assignedRoutine)?_c('assigned-routine-editor',{attrs:{"default-routine":_vm.assignedRoutine}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }